import React from 'react'
import { selectCategoriesItemById, selectSubCategoriesMenu } from '../../store/poiassets/poiassets.selectors'
import cross from '../genericComponents/assets/cross.svg'
import SVGIcon from '../svg/SVGIcon'
import { useSelectorWithProps } from '../utils/react-redux'
import CategorySubMenuStyle from './CategorySubMenuStyle'
import MenuApplicationItem from './MenuApplicationItem'
import s from './MenuSubCategoriesPE.less'
import MenuSubCategoryItem from './MenuSubCategoryItem'
import usePublisherBarreCategorieTag from './usePublisherBarreCategorieTag'

const MenuSubCategoriesPE = ({ categoryId, onMouseLeaveMenu }) => {
  const { subcategories, apps, color } = useSelectorWithProps(selectSubCategoriesMenu, { id: categoryId })
  const { label } = useSelectorWithProps(selectCategoriesItemById, { id: categoryId })

  usePublisherBarreCategorieTag(categoryId)

  if (!categoryId) return <></>

  return (
    <div className={s.container}>
      <div className={s.header}>
        <div className={s.close} onClick={onMouseLeaveMenu}>
          <SVGIcon url={cross} />
        </div>
        <h2 className={s.title}>{label}</h2>
      </div>
      <div className={s.itemsWrapper}>
        <ul className={s.items}>
          {subcategories.map(({ id, iconId, label, rubricIds }) => (
            <MenuSubCategoryItem
              key={`subcategory-${id}`}
              id={id}
              iconId={iconId}
              label={label}
              rubricIds={rubricIds}
              categoryId={categoryId}
              onClick={onMouseLeaveMenu}
            />
          ))}
        </ul>
        <ul className={s.items}>
          {apps.map(({ id, mob_roundImage, name }) => (
            <MenuApplicationItem
              key={`app-${id}`}
              id={id}
              logo={mob_roundImage}
              name={name}
              categoryId={categoryId}
              onClick={onMouseLeaveMenu}
            />
          ))}
        </ul>
        <CategorySubMenuStyle color={color} />
      </div>
    </div>
  )
}

export default MenuSubCategoriesPE
